import config from '@/config';
import {ApiBase} from '@/api/common';

const NO_UPLOAD_FIELDS = [
    'state',
];

export default class VideosI18n extends ApiBase<VideosI18n> {
    public static readonly SLUG: string = 'hint';
    private static readonly URL_BASE: string = config.API_ROOT + '/videos-i18n/';

    public language?: string = undefined;
    public type?: string = 'youtube';
    public path?: string = undefined;
    public start_time?: number = undefined;
    public end_time?: number = undefined;
    public parent_id?: number = undefined;
    public parent_model?: string = undefined;
    public state?: string = 'created';
    public display_condition?: string = undefined;

    public constructor() {
        super({
            urlBase: VideosI18n.URL_BASE,
            filteredFields: NO_UPLOAD_FIELDS,
        });
    }

    public assign(response: any): VideosI18n {
        super.assign(response);
        this.state = 'unchanged';
        return this;
    }
}
